import { EnumHeadingTextBlock } from '../../types/cmsEnums';

export const HEADER_LEVEL_MAP = {
  HEADING_1: 'h1',
  HEADING_2: 'h2',
  HEADING_3: 'h3',
  HEADING_4: 'h4',
  HEADING_5: 'h5',
  HEADING_6: 'h6',
} satisfies Record<EnumHeadingTextBlock, keyof JSX.IntrinsicElements>;

export const HEADER_LEVEL_DEFAULT =
  'HEADING_2' satisfies keyof typeof HEADER_LEVEL_MAP;
